// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1gMcW","header":"PatientBlock_header__1jhq2","label":"PatientBlock_label__3CLp-","option":"PatientBlock_option__33teL"};